__turbopack_context__.v({
  "button": "promotion-product-card-module-scss-module__B9wmZG__button",
  "image": "promotion-product-card-module-scss-module__B9wmZG__image",
  "link": "promotion-product-card-module-scss-module__B9wmZG__link",
  "oldPrice": "promotion-product-card-module-scss-module__B9wmZG__oldPrice",
  "price": "promotion-product-card-module-scss-module__B9wmZG__price",
  "pricePanel": "promotion-product-card-module-scss-module__B9wmZG__pricePanel",
  "root": "promotion-product-card-module-scss-module__B9wmZG__root",
  "title": "promotion-product-card-module-scss-module__B9wmZG__title",
});
